import { Image } from "../image"

const GreyScaleImage = (props)=>{
    const style = [props.style, props.greyscale && { filter: "grayscale(100%)" }]
    return <Image {...props} style={style}/>
}

export default GreyScaleImage